module.exports = __webpack_public_path__ + "img/2022-LevelNext-Rocket-League-Spring-Showcase.e4eadb84.png";